
import { ImageCropper } from "@/components/ui/image-cropper";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface CropDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  imageFile: File | null;
  onCropComplete: (croppedFile: File) => void;
  onCancel: () => void;
  aspectRatio?: number;
  maxWidth?: number;
  maxHeight?: number;
}

export function CropDialog({
  open,
  onOpenChange,
  imageFile,
  onCropComplete,
  onCancel,
  aspectRatio = 1,
  maxWidth = 1200,
  maxHeight = 1200,
}: CropDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Edit Image</DialogTitle>
        </DialogHeader>
        {imageFile && (
          <ImageCropper
            imageFile={imageFile}
            onCropComplete={onCropComplete}
            onCancel={onCancel}
            aspectRatio={aspectRatio}
            maxWidth={maxWidth}
            maxHeight={maxHeight}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
